/* eslint-disable security/detect-object-injection */
import {util, events} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';

/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let accountManagement = (component,profileUtils)=>{
    profileUtils.publishAnalytics(
        component.$analytics.category.personal, 'manageAccountType', 'Click'
    )
}
/**
 *
 * @param {*} showFlag
 */
let toggleLoader = (showFlag)=>{
    if (showFlag) {
        document.getElementById('loader').classList.remove('hidden');
    } else {
        document.getElementById('loader').classList.add('hidden');
    }
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let openHGTaxDialog = (component,profileUtils)=>{
    component.HUTaxDialog = true;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'hu_tax_dialog',
        'opened'
    );
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let closeHGTaxDialog = (component,profileUtils)=>{
    component.HUTaxDialog = false;
    component.dialogError = null;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'hu_tax_dialog',
        'closed'
    );
}

/**
 *
 * @param {*} component
 * @param {*} blob
 */
let updateProfileImageData = (component,blob)=>{
    component.profileImg = blob;
}

const vg_imageEndpoint = '/vgservice/rest/photo-upload-info';
let s3_imageEndpoint = 'https://nuskin-image-test.s3.amazonaws.com';
let image_service = 'https://testimage.nuskin.com/image-service/api/1/';

if (util.RunConfigService.getEnvironmentCode() === 'prod') {
    s3_imageEndpoint = 'https://nuskin-image.s3.amazonaws.com';
    image_service = 'https://image.nuskin.com/image-service/api/1/';
}

let getImageEndpoint = image_service + 'images/';
let uploadImageEndpoint = image_service + 'upload-request.json?file={filename}';
/**
 *
 * @param {*} component
 * @param {*} UserService
 * @param {*} profileUtils
 */
let imageIsUpdated = (component,UserService,profileUtils)=>{
    let user = UserService.getUser();
    let img = getImageEndpoint + component.profileShortKey + '.200.png';
    // the image url
    user.photoURL = img;
    UserService.setUser(user);
    // update Store
    component.updateProfilePic(img);
    component.profileDialog = false;
    component.dialogError = null;
    component.toggleLoader(false);
    events.publish(events.account.PROFILE_IMAGE_UPDATED, img);
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'profile_image',
        'updated'
    );
}
/**
 *
 * @param {*} formData
 * @param {*} filename
 * @param {*} awsInfoUrl
 * @param {*} component
 * @param {*} axios
 * @param {*} marketConfig
 */
let uploadImage = (formData,filename,component,axios,marketConfig)=>{

    let self = component;
    let _marketConfig = marketConfig;

    toggleLoader(true);

    let catchCallBack = function (error) {
        toggleLoader(false);
        self.dialogError = error;
    };


    /**
     * get() short_key info for saving to s3 using
     * awsInfoUrl: image-service/api/1/upload-request.json?file={filename}
     */
    const awsInfoUrl = uploadImageEndpoint.replace('{filename}', filename);
    axios
        .get(awsInfoUrl)
        .then(function (response) {
            if (response.data.action && response.data.action.length) {
                s3_imageEndpoint = response.data.action;
            }
            response.data.inputs.forEach(function (k, _v) {
                if (k.name !== 'short_key') {
                    formData.append(k.name, k.value);
                } else {
                    self.profileShortKey = k.value;
                }
            });

            formData.append('fileName', filename);
            formData.append('file', self.profileImg);

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };

            let configHeaderVG = {
                headers: {
                    client: 'aem',
                    Accept: 'application/json',
                    'content-type': 'application/json',
                    eid: UserService.getUser().eid,
                    id: UserService.getUser().id,
                    client_id: _marketConfig.clientId,
                    client_secret: _marketConfig.clientSecret
                }
            };

            let vgData = {
                id: 'ID3537362',
                name: 'photo',
                key: 'CGDW',
                device: 'web'
            };

            /**
             * Save image in s3 with image data and url info from previous service call
             */
            axios
                .post(s3_imageEndpoint, formData, config)
                .then(function (_response) {
                    vgData.key = self.profileShortKey;
                    vgData.id = UserService.getUser().id;
                    axios
                        /**
                         * Also save info to VnG using
                         * vg_imageEndpoint: vgservice/rest/photo-upload-info
                         */
                        .post(vg_imageEndpoint, vgData, configHeaderVG)
                        .then(function (_res) {
                            // dispatches action with new url
                            // self.updateProfilePic(UserService.getUser().photoURL);
                            self.imageIsUpdated();
                        })
                        .catch(catchCallBack);
                })
                .catch(catchCallBack);
        })
        .catch(catchCallBack);
}
/**
 *
 * @param {*} profileUtils
 * @param {*} component
 */
let openProfileDialog = (profileUtils,component)=>{
    component.profileDialog = true;
    component.$refs.imageInput.destroyAndCreateCroppie(component.profilePic);
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'profile_image_dialog',
        'opened'
    );
}
/**
 *
 * @param {*} profileUtils
 * @param {*} component
 */
let closeProfileDialog = (profileUtils,component)=>{
    component.profileDialog = false;
    component.dialogError = null;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'profile_image_dialog',
        'closed'
    );
}
/**
 *
 * @param {*} profileUtils
 * @param {*} component
 */
let openDOBDialog = (profileUtils,component)=>{
    component.DOBDialog = true;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'date_of_birth_dialog',
        'opened'
    );
}
/**
 *
 * @param {*} profileUtils
 * @param {*} component
 */
let closeDOBDialog = (profileUtils,component)=>{
    component.birthDate = '';
    component.DOBDialog = false;
    component.dialogError = null;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'date_of_birth_dialog',
        'closed'
    );
}
/**
 *
 * @param {*} component
 * @param {*} ProfileService
 * @param {*} profileUtils
 */
let AddDateOfBirth = (component,ProfileService,profileUtils)=>{
    let self = component;
    let info = {birthDate : 'default'};
    info.birthDate = component.birthDate;
    ProfileService.updatePerson(info)
        .then(function (_response) {
            self.account.persons[0].birthDate = info.birthDate;
            const accountData = JSON.parse(localStorage.getItem('nuskin.account.data')) || {};
            localStorage.setItem(
                'nuskin.account.data',
                JSON.stringify({
                    ...accountData,
                    user: {
                        ...accountData.user,
                        birthDate: info.birthDate
                    }
                })
            )
            self.DOBDialog = false;
            self.closeDOBDialog();
            profileUtils.publishAnalytics(
                self.$analytics.category.personal,
                'date_of_birth',
                'updated'
            );
        })
        .catch(error => {
            component.dialogError = error;
        });
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let closeAddressDialog = (component,profileUtils)=>{
    component.addressDialog = false;
    component.dialogError = null;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'address_dialog',
        'closed'
    );
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let openAddressDialog = (component,profileUtils)=>{
    component.modelObject = component.addressLocal;
    component.modelResponse = component.modelObject;
    if(component.modelObject.line1) component.modelObject.address1 = component.modelObject.line1;
    if(component.modelObject.line2) component.modelObject.address2 = component.modelObject.line2;
    component.addressDialog = true;
    profileUtils.publishAnalytics(
        component.$analytics.category.personal,
        'address_dialog',
        'opened'
    );
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 * @param {*} ProfileService
 */
let updateAddress = (component,profileUtils,ProfileService)=>{
    let self = component;
    let addressInfo = {addresses: {local: {}}};
    addressInfo.addresses.local = self.modelResponse;

    ProfileService.updateAccountInfo(addressInfo)
        .then(response => {
            if (response.data && response.data.account) {
                self.setAccount(response.data.account);
                self.closeAddressDialog();
                profileUtils.publishAnalytics(
                    self.$analytics.category.personal,
                    'address',
                    'updated',
                    {
                        email: self.account.email
                    }
                );
            }
        })
        .catch(error => {
            self.dialogError = error;
        });
}

/**
 *
 * @param {*} component
 */

let dataUpdate = (component, data)  => {
    component.modelResponse = data
}

export default {
    accountManagement:accountManagement,
    toggleLoader:toggleLoader,
    openHGTaxDialog:openHGTaxDialog,
    closeHGTaxDialog:closeHGTaxDialog,
    updateProfileImageData:updateProfileImageData,
    imageIsUpdated:imageIsUpdated,
    uploadImage:uploadImage,
    openProfileDialog:openProfileDialog,
    closeProfileDialog:closeProfileDialog,
    openDOBDialog:openDOBDialog,
    closeDOBDialog:closeDOBDialog,
    AddDateOfBirth:AddDateOfBirth,
    closeAddressDialog:closeAddressDialog,
    openAddressDialog:openAddressDialog,
    updateAddress:updateAddress,
    dataUpdate: dataUpdate
};
